import { BrowserRouter } from 'react-router-dom'
import { ChatBotProvider } from '@/contexts/ChatBotContext'
import { CookieConsentProvider } from '@/contexts/CookieConsentContext'
import { LanguageRouter } from '@/components/LanguageRouter'
import { OverlayProvider } from '@/components/layout/OverlayProvider'

export default function App() {
  return <BrowserRouter><CookieConsentProvider><ChatBotProvider><OverlayProvider>
    <LanguageRouter />
  </OverlayProvider></ChatBotProvider></CookieConsentProvider></BrowserRouter>
}
